import { FunctionComponent, useState, useEffect } from "react";
import styles from "./AddHeaders.module.css";
import Loading from "../../Components/Loading/Loading";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import axios from "axios";
import { url } from "../../Values/constants";
import { showSnackbarAction } from "../../Redux/actions";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import DropDownText from "../../Components/DropDownText/DropDownText";
import InputTextValue from "../../Components/TextInput/InputTextValue";

type props = {
    history: any;
    theme: any;
    user: any;
};
const AddHeaders: FunctionComponent<props> = ({ history, theme, user }) => {
    const dispatcher = useDispatch();
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [load, setLoad] = useState(false);
    const [selectedScreen, setSelectedScreen] = useState<any>({ label: "Select", value: "Select" });
    const [selectedIndustries, setSelectedIndustries] = useState<any>({ label: "Select", value: "Select" });
    const [visible, setVisible] = useState(false);
    const [allIndustries, setallIndustries] = useState<{ industry_id: string, status: string, industry_name: string, screens: string[] }[]>([]);
    const [inputValues, setInputValues] = useState<string[]>([]);
    const [defaultHeaders, setdefaultHeaders] = useState<MyObject[]>([]);
    const [selectScreen, setSelectScreen] = useState<string[]>([]);

    type MyObject = {
        label: string;
        value: string;
        is_mandatory: string;
        hide_field: string;
    };

    const myArray: MyObject[] = defaultHeaders;

    const handleInputChange = (index: number, value: string, label: string) => {
        setInputValues(prevValues => {
            const newValues = [...prevValues];
            newValues[index] = value;
            return newValues;
        });
    };

    const renderBatch = (batch: MyObject[]) => {
        return (
            <Grid container spacing={isMobile ? 2 : 3}>
                {batch.map((obj, index) => (
                    obj.hide_field === "false" && (
                        <Grid
                            item
                            xs={12}    // full width on mobile
                            sm={6}     // 2 per row on tablets
                            md={4}     // 3 per row on medium screens
                            lg={3}     // 4 per row on desktops
                            key={index}
                        >
                            <InputTextValue
                                title={obj.value}
                                value={inputValues[index] || ""}
                                onChange={(e) => handleInputChange(index, e.target.value, obj.label)}
                                required={obj.is_mandatory === "true"}
                            />
                        </Grid>
                    )
                ))}
            </Grid>
        );
    };

    const batches: MyObject[][] = [];
    const batchSize = 10;
    for (let i = 0; i < myArray.length; i += batchSize) {
        batches.push(myArray.slice(i, i + batchSize));
    }

    const handleScreenChange = (event: any) => {
        const selectedValue = event.target.value;
        setSelectedScreen({ label: selectedValue, value: selectedValue });
    };

    const handleIndustriesChange = (event: any) => {
        const selectedValue = event.target.value;
        setSelectedIndustries({ label: selectedValue, value: selectedValue });
    };

    useEffect(() => {
        getAllIndustries();
    }, []);

    useEffect(() => {
        if (selectedIndustries.value !== "Select") {
            const selectScreen = allIndustries.filter((industry: any) => industry.industry_id === selectedIndustries.value);
            setSelectScreen(selectScreen[0]?.screens);
        }
    }, [selectedIndustries]);

    useEffect(() => {
        if (selectedScreen.value !== "Select" && selectedIndustries.value !== "Select") {
            if (selectedScreen.value === "DefaultContacts") {
                const result = checkScreens(selectedIndustries.value, setVisible);
                if (!result) {
                    setVisible(true);
                    getDefaultHeaders(selectedIndustries.value, selectedScreen.value);
                }
            } else {
                setVisible(true);
                getDefaultHeaders(selectedIndustries.value, selectedScreen.value);
            }
        }
    }, [selectedScreen, selectedIndustries]);

    const create = async (e: any) => {
        let screen = "";
        e.preventDefault();
        setLoad(true);
        const updatedArray = myArray.map((obj, index) => ({
            ...obj,
            value: inputValues[index] !== undefined ? inputValues[index] : obj.value,
        }));
        if (selectedScreen.value == "DefaultContacts") {
            screen = "Contacts";
        } else if (selectedScreen.value == "DefaultProjects") {
            screen = "Projects";
        } else if (selectedScreen.value == "DefaultTasks") {
            screen = "Tasks";
        } else if (selectedScreen.value == "DefaultApi") {
            screen = "Api";
        } else if (selectedScreen.value == "DefaultCallLogs") {
            screen = "CallLogs";
        } else {
            screen = "Default";
        }

        const getSingleInd = allIndustries.filter((obj: any) => obj.industry_id === selectedIndustries.value);
        const apiData = {
            industry_id: selectedIndustries.value,
            industry_name: getSingleInd[0]['industry_name'],
            created_by: user.user_email,
            headers: updatedArray,
            screen_name: screen
        };
        try {
            const res = await axios.post(url + '/headers/insert', apiData);
            setInputValues([]);
            if (res.status == 200) {
                if (res.data === "Headers already exist") {
                    dispatcher(showSnackbarAction(res.data, "error"));
                }
                else {
                    dispatcher(showSnackbarAction(res.data, "success"));
                }
                history.replace("/headers")
                setLoad(false);
            } else {
                dispatcher(showSnackbarAction(res.data, "error"));
                setLoad(false);
            }
            setLoad(false);
        } catch (e) {
            setLoad(false);
        }
    };

    const getDefaultHeaders = async (industry: any, screen: any) => {
        setLoad(true);
        const apiData = {
            industry_id: "ind001",
            screen_name: screen
        };
        try {
            const res = await axios.post(url + '/headers/getHeaders', apiData);
            setdefaultHeaders(res?.data?.headers);
            setLoad(false);
        } catch (e) {
            setLoad(false);
        }
    };

    const checkScreens = (industry_id: any, setVisible: any) => {
        const singleIndustryData = allIndustries.find(item => item.industry_id === industry_id);
        if (singleIndustryData) {
            if (!singleIndustryData.screens.includes("Projects") || !singleIndustryData.screens.includes("Tasks")) {
                setVisible(false);
                dispatcher(showSnackbarAction("Please create Projects and Tasks screen headers before creating Contacts !", "error"));
                return true;
            } else {
                return false;
            }
        }
    };

    const getAllIndustries = async () => {
        setLoad(true);
        const apiData = {
            status: "Pending"
        };
        try {
            const res = await axios.post(url + '/headers/getAllIndustries', apiData);
            setallIndustries(res.data);
            setLoad(false);
        } catch (e) {
            console.log("Provide Exception By get all industries :", e);
            setLoad(false);
        }
    };

    // FIXED OPTION BUILDER
    const screenOptions: { label: string; value: string }[] = [];

    if (!selectScreen.includes("Projects")) {
        screenOptions.push({ label: "Projects", value: "DefaultProjects" });
    }
    if (!selectScreen.includes("Tasks")) {
        screenOptions.push({ label: "Tasks", value: "DefaultTasks" });
    }
    if (!selectScreen.includes("Contacts")) {
        screenOptions.push({ label: "Contacts", value: "DefaultContacts" });
    }

    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
    const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

    return (
        <Box className={styles.parent} sx={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
            {load && <Loading />}
            {isMobile && (
                <Box
                    className="d-flex flex-row w-100 px-4 pt-4"
                >
                    <h5
                        style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
                    >
                        Add Headers Details
                    </h5>
                </Box>
            )}
            <Box
                className="w-100 d-flex flex-column gap-2 px-4"
                style={{
                    padding: isMobile ? '0' : '',
                    maxWidth: isMobile ? '100vw' : undefined,
                    margin: isMobile ? '0' : '0 auto',
                    overflowY: isMobile ? 'auto' : undefined,
                    maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
                }}
            >
                <p style={{ margin: 0, paddingTop: "10px" }}>(**Before creating and launching the organization, create headers for all five screens to establish a cohesive and consistent visual identity)</p>
                <form
                    className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
                    style={{
                        ...cardContainerStyles,
                        padding: isMobile ? '16px' : '32px',
                        boxSizing: 'border-box',
                        minHeight: isMobile ? 'auto' : undefined,
                        marginBottom: 16
                    }}
                >
                    <Grid container spacing={isMobile ? 2 : 3}>
                        <Grid item xs={12} sm={6}>
                            <DropDownText
                                title="Industries"
                                options={allIndustries.map(item => {
                                    return {
                                        value: item?.industry_id,
                                        label: item?.industry_name
                                    };
                                })}
                                value={selectedIndustries.value === "Select" ? "" : selectedIndustries.value}
                                onChange={handleIndustriesChange}
                                required
                                labelKey="label"
                                valueKey="value"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DropDownText
                                title="Screen"
                                options={screenOptions}
                                value={selectedScreen.value === "Select" ? "" : selectedScreen.value}
                                onChange={handleScreenChange}
                                required
                                labelKey="label"
                                valueKey="value"
                            />
                        </Grid>
                    </Grid>
                </form>
            </Box>
            {visible && <Box
                className="w-100 d-flex flex-column gap-2 px-4"
                style={{
                    padding: isMobile ? '0' : '',
                    maxWidth: isMobile ? '100vw' : undefined,
                    margin: isMobile ? '0' : '0 auto',
                    overflowY: isMobile ? 'auto' : undefined,
                    maxHeight: isMobile ? 'calc(100vh - 320px)' : undefined,
                }}
            >
                <form
                    className={`card shadow rounded ${!isMobile ? ` ${styles.forcePadding}` : ""}`}
                    style={{
                        ...cardContainerStyles,
                        padding: isMobile ? '16px' : '32px',
                        boxSizing: 'border-box',
                        minHeight: isMobile ? 'auto' : undefined,
                        marginBottom: isMobile ? '50px' : 0,
                    }}
                >
                    {renderBatch(myArray)}
                    <Box sx={{marginTop:"20px"}}>
                        <StyledSubmitButton
                            onClick={(e) => create(e)}
                            themeMode={themeMUI.palette.mode}
                            isMobile={isMobile}
                        >
                            {load ? (
                                <span style={{ display: "flex", justifyContent: "center" }}>
                                    <Circles color="#fff" height={20} width={20} />
                                </span>
                            ) : (
                                <>Submit</>
                            )}
                        </StyledSubmitButton>
                    </Box>
                </form>
            </Box>}
        </Box>
    );
};

const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode,
        user: state.user.data
    };
};

export default connect(mapStateToProps)(AddHeaders);
